import { useState, useEffect } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { getTelemetryEventsBySessionAndUser } from '../../workspace/service/telemetryService'
import ReplayModal from '../../workspace/components/ReplayModal'

const SESSION_DATA = {
  658: {
    task: 'Create a class named Rectangle that takes two parameters in its constructor: width and height.\n\n1.) Include a method named get_area that returns the area (width * height)\n\n2.) Include a __str__ method so that printing a Rectangle displays: Rectangle(4x5, area=20)',
    testCases: [
      { testName: 'Normal rectangle area', result: null },
      { testName: 'Edge case: width is 0', result: null },
      { testName: 'Edge case: height is 0', result: null },
      { testName: 'String representation', result: null },
      { testName: 'String with zero', result: null },
    ]
  },
  659: {
    task: 'Write a function called is_palindrome that takes a string and returns True if the string reads the same forwards and backwards, and False otherwise. Ignore uppercase and lowercase differences.',
    testCases: [
      { testName: 'Normal palindrome', result: null },
      { testName: 'Not a palindrome', result: null },
      { testName: 'Mixed case palindrome', result: null },
      { testName: 'Single character', result: null },
    ]
  },
 654: {
  task: "You are given a list of lists called grade_book, where each inner list contains a student's test scores.\n\nComplete the following steps:\n\n1.) A new student joined the class with scores [78, 84, 91]. Add their scores to grade_book.\n2.) The first student's third score was entered incorrectly. Update it to 80.\n3.) Using a nested for loop, print every individual score in grade_book, one per line.",
  starterCode: "grade_book = [[88, 92, 75], [70, 85, 90], [95, 88, 82]]",
  testCases: [
    { testName: 'New student added to grade book', result: null },
    { testName: 'New student has correct scores', result: null },
    { testName: "First student's third score updated", result: null },
    { testName: 'Print all scores', result: null },
  ]
},
}

export default function ReplayModalView({ session, currentUser, onBack }) {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true)
        const data = await getTelemetryEventsBySessionAndUser(
          session.vispiSessionId, 
          session.studentUserId
        )

        if (!data || data.length === 0) {
          setError('No telemetry events found for this session.')
          return
        }

        data.sort((a, b) => a.timestamp - b.timestamp)
        setEvents(data)
      } catch (err) {
        console.error('Error fetching telemetry events:', err)
        setError('Failed to load session: ' + err.message)
      } finally {
        setLoading(false)
      }
    }
    fetchEvents()
  }, [session])

  if (loading) {
    return (
      <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#111827' }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress sx={{ color: '#3b82f6' }} />
          <Typography variant="body2" sx={{ mt: 2, color: '#9ca3af' }}>Loading session...</Typography>
        </Box>
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#111827' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body1" sx={{ mb: 2, color: '#f87171' }}>{error}</Typography>
          <Typography 
            variant="body2" 
            sx={{ color: '#60a5fa', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
            onClick={onBack}
          >
            Back to queue
          </Typography>
        </Box>
      </Box>
    )
  }

  const sessionInfo = SESSION_DATA[session.vispiSessionId] || { task: '', testCases: [] }

  return (
    <ReplayModal
      onClose={onBack}
      events={events}
      task={sessionInfo.task}
      testCases={sessionInfo.testCases}
      starterCode={sessionInfo?.starterCode || ''}
      sessionId={session.vispiSessionId}
      studentUserId={session.studentUserId}
      labelerName={currentUser}
      studentName={session.student}
    />
  )
}